import { format } from "date-fns";
import _ from "lodash";
import { connect } from "react-redux";
import { Actions as ACTIONS } from "../../store/actions/auditLogActions";
import { auditTypes } from "./AuditTypes";
import { EyeIcon } from "@heroicons/react/20/solid";

export const AuditRow = ({ logEntry, user, viewDetails }) => {
	return (
		<tr>
			<td className="pl-10">{logEntry.userName || logEntry.userId}</td>
			<td className="pl-16">{_.capitalize(logEntry.action)}</td>
			<td className="pl-12">{auditTypes[logEntry.type]?.name}</td>
			<td className="pl-0">{format(new Date(logEntry.date), "do MMM yyyy HH:mm")}</td>
			<td>{logEntry.dated ? format(new Date(logEntry.dated), "do MMM yyyy") : null}</td>
			<td>
				<button
					className="btn btn-xs btn-default"
					onClick={() => viewDetails(logEntry)}
				>
					<EyeIcon
						className="h-5 w-5 text-dark-gray"
						style={{ marginTop: "3px" }}
					/>
				</button>
			</td>
		</tr>
	);
};

const mapStateToProps = (state, ownProps) => {
	const { logEntry } = ownProps;
	const { userId } = logEntry;

	// find user who made log entry

	return {
		taxOptions: state.taxOptions,
	};
};

const mapDispatchToProps = (dispatch) => ({
	viewDetails: (item) => dispatch(ACTIONS.showAuditLogDetail({ show: true, item })),
});

export default connect(mapStateToProps, mapDispatchToProps)(AuditRow);
